import { Box } from "@mui/material"

const About = () => {
  return (
    <Box minHeight={"79vh"}>
      
    </Box>
  )
}

export default About
